

import React, { Component } from 'react';
import { Editor, EditorState, convertFromRaw, CompositeDecorator } from 'draft-js';
import _isEqual from 'lodash.isequal';
import MentionTag from '../../../RichTextEditor/components/MentionTag';
import './_content-view.scss';












function getContentState(content, truncate) {
  if (truncate && content.blocks.length > 3) {
    content.blocks.filter((block, index) => index < 3).map((block, index) => {
      if (index === 2) {
        return {
          ...block,
          text: `${block.text}...`
        };
      }
      return block;
    });
    return convertFromRaw(content);
  }
  return convertFromRaw(content);
}

function getEntityStrategy(mutability) {
  return (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(
      (character) => {
        const entityKey = character.getEntity();
        if (entityKey === null) {
          return false;
        }
        return contentState.getEntity(entityKey).getMutability() === mutability;
      },
      callback
    );
  };
}

function getDecorator() {
  return new CompositeDecorator([
  {
    strategy: getEntityStrategy('SEGMENTED'),
    component: MentionTag
  }]
  );
}

class ContentView extends Component {
  constructor(props) {
    super(props);

    const { content, truncate } = props;
    const contentState = getContentState(content, truncate);

    const decorator = getDecorator();

    this.state = {
      editorState: EditorState.createWithContent(contentState, decorator)
    };
  }

  componentDidUpdate(prevProps) {
    const { content } = this.props;

    if (!_isEqual(prevProps.content, content)) {this.setEditor();}
  }

  setEditor = () => {
    const { content, truncate } = this.props;
    const contentState = getContentState(content, truncate);

    const decorator = getDecorator();

    this.setState({ editorState: EditorState.createWithContent(contentState, decorator) });
  };

  render() {
    const { editorState } = this.state;

    return (
      <div className="content-view">
        <Editor
          readOnly
          editorState={editorState} />

      </div>);

  }
}

export default ContentView;